import React from "react";
import moment from "moment";
import values from "lodash/values";
import pick from "lodash/pickBy";
import { Link } from "react-router";
import { RaisedButton, FlatButton, TextField } from "material-ui";
import { Table, Sort, Tr, Td } from "reactable";

import connectToStores from "alt-utils/lib/connectToStores";
import GiftCardActions from "../actions/GiftCardActions";
import GiftCardStore from "../stores/GiftCardStore";

import WorkingIndicator from "./partials/working-indicator.jsx";
import CurrencyField from "./partials/currency-field.jsx";
import LinkLike from "./partials/link-like.jsx";
import BaseOverlay from "./partials/overlays/base.jsx";
import { formatPrice, clientSideDownload } from "../util";
import giftCardUtil from "../utils/GiftCardUtil";
import UserStore from "../stores/UserStore";
import DatePicker from "./partials/datepicker.jsx";
import InjectedSelect from "./partials/injected-select.jsx";

class GiftCards extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isIssuingNewGiftCard: false,
      isAdjustingGiftCard: false,
      giftCardId: "",
      recipientEmail: "",
      recipientName: "",
      giftScheduledSend: new Date(),
      amount: "",
      code: "",
      eventBucket: undefined
    };

    this._makeRowForGiftCard = this._makeRowForGiftCard.bind(this);

    this.showIssueGiftCardModal = this.showIssueGiftCardModal.bind(this);
    this.hideIssueGiftCardModal = this.hideIssueGiftCardModal.bind(this);
    this.showAdjustGiftCardModal = this.showAdjustGiftCardModal.bind(this);
    this.hideAdjustGiftCardModal = this.hideAdjustGiftCardModal.bind(this);
    this.handleGiftCardAdjustment = this.handleGiftCardAdjustment.bind(this);
    this.handleGiftCardScheduledSendChange =
      this.handleGiftCardScheduledSendChange.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.handleCodeChange = this.handleCodeChange.bind(this);
    this.issueGiftCard = this.issueGiftCard.bind(this);
  }

  static getStores() {
    return [GiftCardStore, UserStore];
  }

  static getPropsFromStores() {
    return GiftCardStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {};
  }

  _makeRowForGiftCard(giftCard) {
    return (
      <Tr
        style={
          this.props.location.query.gift_card_id === giftCard.id
            ? {
                backgroundColor: "#fff176",
                boxShadow: "1px 1px 10px rgba(0,0,0,0.2)"
              }
            : {}
        }
      >
        <Td column="Code">{giftCard.code}</Td>
        <Td column="Balance">
          {formatPrice(giftCard.balance, { currency: giftCard.currency })}
        </Td>
        <Td column="Balance Events">
          <div>
            {giftCard.balance_events.map(e => {
              return (
                <div>
                  <span style={{ fontVariantNumeric: "tabular-nums" }}>{`${
                    e.balance_change > 0 ? "+" : "−"
                  }${formatPrice(Math.abs(e.balance_change), { currency: giftCard.currency })}`}</span>{" "}
                  ({`${e.description} @ ${moment(e.created_at).format("lll")}`}
                  {e.order ? (
                    <span>
                      {" "}
                      &middot;{" "}
                      <a href={`/orders/${e.order}`} target="_blank">
                        view
                      </a>
                    </span>
                  ) : null}
                  )
                </div>
              );
            })}
          </div>
        </Td>
        <Td column="Actions">
          <div style={{ display: "flex", gap: 4 }}>
            <LinkLike
              onTouchTap={() => {
                this.showAdjustGiftCardModal(giftCard);
              }}
            >
              Adjust
            </LinkLike>
            <LinkLike
              onTouchTap={() => {
                if (
                  window.confirm(
                    "Are you sure you would like to delete this gift card?"
                  )
                ) {
                  GiftCardActions.delete(giftCard.id);
                }
              }}
            >
              Delete
            </LinkLike>
          </div>
        </Td>
      </Tr>
    );
  }

  showIssueGiftCardModal() {
    this.setState({ isIssuingNewGiftCard: true });
  }

  hideIssueGiftCardModal() {
    this.setState({ isIssuingNewGiftCard: false, amount: "", code: "" });
  }

  showAdjustGiftCardModal(giftCard) {
    this.setState({
      isAdjustingGiftCard: true,
      giftCardId: giftCard.id,
      recipientEmail: giftCard.recipientEmail,
      recipientName: giftCard.recipientName,
      giftScheduledSend: giftCard.giftScheduledSend
    });
  }

  hideAdjustGiftCardModal() {
    this.setState({
      isAdjustingGiftCard: false,
      giftCardId: "",
      recipientEmail: "",
      recipientName: "",
      giftScheduledSend: new Date()
    });
  }

  handleAmountChange(e) {
    this.setState({ amount: e.target.value });
  }

  handleCodeChange(e) {
    this.setState({ code: e.target.value.toUpperCase(0) });
  }

  handleGiftCardAdjustment(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleGiftCardScheduledSendChange(value) {
    this.setState({
      giftScheduledSend: value
    });
  }

  async fetchGiftCardCSV() {
    const results = await giftCardUtil.fetchCSV(UserStore.getState().apiKey);

    clientSideDownload("gift_cards.csv", "text/csv", results);
  }

  adjustGiftCard(sendEmail) {
    GiftCardActions.adjustGiftCard({
      giftCard: {
        id: this.state.giftCardId,
        amount: this.state.amount,
        recipientEmail: this.state.recipientEmail,
        recipientName: this.state.recipientName,
        giftScheduledSend: this.state.giftScheduledSend
      },
      options: {
        sendEmail
      }
    });
    this.hideAdjustGiftCardModal();
  }

  issueGiftCard() {
    GiftCardActions.create({
      initial_balance: this.state.amount,
      code: this.state.code,
      event_bucket: this.state.eventBucket
    });
    this.hideIssueGiftCardModal();
  }

  componentWillMount() {
    GiftCardActions.fetchAll();
  }

  render() {
    let styles = this.getStyles(),
      giftCards = values(this.props.giftCards),
      rows = giftCards.map(this._makeRowForGiftCard);

    if (giftCards.length === 0 && GiftCardStore.getState().isFetching) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <BaseOverlay
          title={"Issue new gift card"}
          useMuiDefaultStyle={true}
          actions={[
            <FlatButton
              label={"Close"}
              onTouchTap={this.hideIssueGiftCardModal}
            />,
            <FlatButton
              disabled={!this.state.amount || !this.state.eventBucket}
              primary={true}
              label={"Issue new gift card"}
              onTouchTap={this.issueGiftCard}
            />
          ]}
          modal={true}
          open={this.state.isIssuingNewGiftCard}
          onRequestClose={this.hideIssueGiftCardModal}
        >
          <div>
            <TextField
              floatingLabelText="Code"
              floatingLabelFixed={true}
              placeholder="Autogenerated if left blank"
              value={this.state.code}
              onChange={this.handleCodeChange}
            />
          </div>
          <div>
            <CurrencyField
              floatingLabelText="Initial balance"
              floatingLabelFixed={true}
              placeholder="$0.00"
              value={this.state.amount}
              onChange={this.handleAmountChange}
            />
          </div>
          <div>
            <InjectedSelect
              value={this.state.eventBucket}
              label={"Event Bucket"}
              labelFormatter={e => e.name}
              type="event_buckets"
              onChange={e => this.setState({ eventBucket: e })}
            />
          </div>
        </BaseOverlay>
        <BaseOverlay
          title="Adjust Gift Card"
          useMuiDefaultStyle={true}
          actions={[
            <FlatButton
              label="Close"
              onTouchTap={this.hideAdjustGiftCardModal}
            />,
            <FlatButton
              label="Adjust"
              onTouchTap={() => this.adjustGiftCard(false)}
            />,
            <FlatButton
              label="Adjust and Resend Notification"
              onTouchTap={() => this.adjustGiftCard(true)}
            />
          ]}
          open={this.state.isAdjustingGiftCard}
          modal={true}
          onRequestClose={this.hideAdjustGiftCardModal}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              padding: "20px"
            }}
          >
            <TextField
              floatingLabelText="Recipient Email"
              floatingLabelFixed={true}
              value={this.state.recipientEmail}
              onChange={this.handleGiftCardAdjustment}
              name="recipientEmail"
            />
            <TextField
              floatingLabelText="Recipient Name"
              floatingLabelFixed={true}
              value={this.state.recipientName}
              onChange={this.handleGiftCardAdjustment}
              name="recipientName"
            />
            <DatePicker
              label="Schedule Send Date"
              floatingLabelFixed={true}
              value={this.state.giftScheduledSend}
              onChange={this.handleGiftCardScheduledSendChange}
              name="giftScheduledSend"
              minDate={new Date()}
            />
          </div>
        </BaseOverlay>
        <RaisedButton label="Download CSV" onTouchTap={this.fetchGiftCardCSV} />
        <Table
          className="bordered striped responsive-table"
          sortable={[{ column: "Code", sortFunction: Sort.CaseInsensitive }]}
          defaultSort={{ column: "Code", direction: "asc" }}
          columns={["Code", "Balance", "Balance Events", "Actions"]}
          filterable={["Code"]}
          filterPlaceholder="Type to filter..."
        >
          {rows}
        </Table>
        {rows.length === 0 ? (
          <div className="empty-table-message">
            No gift cards yet.{" "}
            {UserStore.getUserId() === "65c4bbc05cac700026c08f6e" ? (
              <LinkLike onTouchTap={this.showIssueGiftCardModal}>
                Manually issue a new gift card.
              </LinkLike>
            ) : null}
          </div>
        ) : null}
        <div
          style={{
            marginTop: 20,
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          {UserStore.getUserId() === "65c4bbc05cac700026c08f6e" ||
          UserStore.getUserId() === "63922914aa56a7004570d9c8" ||
          UserStore.getUserId() === "6086c26f92857b003011dbd1" ||
          UserStore.getUserId() === "5eb1e2d3dd5658002f70a5dc" ||
          UserStore.getUserId() === "5eb033f1e514ca0029210402" ? (
            <RaisedButton
              label="Manually issue new gift card"
              primary={true}
              onTouchTap={this.showIssueGiftCardModal}
            />
          ) : null}
          <RaisedButton
            label="Download CSV"
            onTouchTap={this.fetchGiftCardCSV}
          />
        </div>
      </div>
    );
  }
}

export default connectToStores(GiftCards);



// WEBPACK FOOTER //
// ./src/app/components/gift-cards.jsx